// src/api/apiClient.ts
// Direct export alias matching the BEST_PRACTICES.md integration guide.
export {
  default,
  apiClient,
  syncCsrfToken,
  setCsrfToken,
  getCsrfToken,
} from '@/services/axios.instance'

export const API_BASE_URL =
  import.meta.env['VITE_API_URL'] || 'https://diffusion-drone-overpay.ngrok-free.dev'
